const logoGroupModules = [
    {
        selector: '[data-react="logoGroupModules"]',
        path: { filename: 'App' },
    },
];

export { logoGroupModules };
